






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    onMounted(async () => {
      if(context.root.$route.query.error_kind){
        const error_kind = context.root.$route.query.error_kind as string;
        let message = "";
        if(error_kind == "user_not_exists"){
          message = "ユーザー情報がデータベースから削除されています。ログイン画面からやり直してください。";
        }else if(error_kind == "account_mismatch"){
          message = "認証したMicrosoftアカウントはログインしているユーザーとメールアドレスが異なります。ログインしているユーザーのメールアドレスと一致するMicrosoftアカウントで認証してください。";
        }else{
          message = "Microsoft認証に失敗しました。もう一度やり直してください。";
        }

        alert(message);
        context.root.$router.push('/teacher_site/sheet_list').catch(() => {});
      }else{
        context.root.$router.push(context.root.$store.state.gauthRedirectPath).catch(err => {});
      }
    });

    return {
      ...toRefs(state),
    }
  }
})
